const getPath = require('./get-path')
const currencyFormatter = require('currency-formatter')
const m = require('moment')
const walkTree = require('./where').walkTree
		       
const transformGroupValue = (fn, val) => {
  const d = m(val)
  switch(fn) {
  case 'CALENDAR_MONTH':
    return d.month() + 1
  case 'CALENDAR_QUARTER':
    return d.quarter()
  case 'CALENDAR_YEAR':
    return d.year()
  case 'DAY_IN_MONTH':
    return d.date()
  case 'DAY_IN_WEEK':
    return d.day() + 1
  case 'DAY_ONLY':
    return d.format('YYYY-MM-DD')
  case 'HOUR_IN_DAY':
    return d.hour()
  case 'WEEK_IN_YEAR':
    return d.week() + 1
  }
}

const group = (data, groups, fields) => {
  if(!groups.length) return data
  let grp = groups[0]
  let fieldPath = grp.fieldPathArray.join('.')
  const field = fields.find(f => f.fieldPath === fieldPath)
  let groupedData = data.reduce((grouped, row) => {
    let groupVal = getPath(row, grp.fieldPathArray)
    if(grp.functionName) groupVal = transformGroupValue(grp.functionName, groupVal) 

//    if(field.type === 'DATE' || field.type === 'DATETIME' && groupVal) groupVal = 
//    if(groupVal) {
      grouped[groupVal] = grouped[groupVal] || []
      grouped[groupVal].push(row)
    //    }

    return grouped
  }, {})

  Object.keys(groupedData).forEach(k => {
    groupedData[k] = group(groupedData[k], groups.slice(1), fields)
  })
  return groupedData
}

const toNumber = (val) => {
  if (typeof val === 'number') {
    return val
  }
  return val && Number(val.replace(/[^0-9\.]+/g, '')) !== 'NaN' ? Number(val.replace(/[^0-9\.]+/g, '')) : 0
}

const aggregate = (groupData, fields, groups, fieldDescription = [], row = {}, rows = []) => {
  if(!groups || !groups.length) {
    fields.map(ff => {
      let f = ff.field
      let fieldName = ff.name && ff.name.value
      if(f.arguments) {
        let fPath = f.arguments.value.reduce((a, v) => a.concat(v.values), [])
	let fName = fPath.join('.')
        let fDescription = fieldDescription.find(f => f.fieldPath == fName)

        fieldName = fieldName || f.name + '(' + fName + ')'
        switch(f.name && f.name.toLowerCase()) {
          case 'sum':
            row[fieldName] = groupData.reduce((agg, obj) => agg += toNumber(getPath(obj, fPath)), 0)
            //row[fieldName] = groupData.length > 0 && fDescription && fDescription.type === 'CURRENCY'  ? currencyFormatter.format(tempVal, { locale: 'en-US' }) : tempVal
            break
          case 'avg':
            row[fieldName] = groupData.reduce((agg, obj) => agg += toNumber(getPath(obj, fPath)), 0) / groupData.length
            //row[fieldName] = groupData.length > 0 && fDescription && fDescription.type === 'CURRENCY' ? currencyFormatter.format(avgVal, { locale: 'en-US' }) : avgVal
            break
          case 'min':
            row[fieldName] = Math.min.apply(null, groupData.map(obj => toNumber(getPath(obj, fPath))))
            break
          case 'max':
            row[fieldName] = Math.max.apply(null, groupData.map(obj => toNumber(getPath(obj, fPath))))
            break
          case 'count':
            row[fieldName] = groupData.length
            break
        }
      }
    })
    rows.push(row)
    return rows
  }

  let currGroup = groups[0] && groups[0].fieldPathArray.join('.')
  let currGroupFunction = groups[0] && groups[0].functionName
  let currGroupField = fieldDescription.find(f => f.fieldPath === currGroup)
  
  if (!currGroupField && currGroupFunction) {
    //try extract function parameter
    currGroupField = fieldDescription.find(f =>
      fieldPath.replace(currGroupFunction, '').indexOf(currGroup) > -1
    )
  }

  currGroup = currGroupField && currGroupField.aggregateAlias || currGroup
  Object.keys(groupData).forEach(k => {
    let o = Object.assign({}, row, { [currGroup]: k })

    aggregate(groupData[k], fields, groups.slice(1), fieldDescription, o, rows)
  })
  if(!Object.keys(groupData).length) {
    aggregate([], fields, groups.slice(1), fieldDescription, {}, rows)
  }
  return rows
}

const groupAndAggregate = (data, fields, groups, fieldDescription) => {
  let d = data.slice()
  return aggregate(group(d, groups, fieldDescription), fields, groups, fieldDescription)
}

const having = (data, conditions, fieldDescription) => {
  let fieldMap = fieldDescription.reduce((obj, f) => {
    obj[f.fieldPath] = f
    return obj
  }, {})

  let res = data.filter(item => walkTree(item, conditions, fieldMap))
  return res
  /*
  return data.filter(row => {
    for(let c of conditions) {
      if (!c.operation || !c.left || !c.right) return false;
      let leftVal = row[c.left.value]
      //if not found by alias, try find by <FUNTION(argument)>
      if (!leftVal) {
        fields.find()
      }
    }
      return true
    })
     */
}

module.exports = {
  groupAndAggregate,
  aggregate,
  having
}
